var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-blue-100 rounded"},[_c('div',{staticClass:"text-xs px-3 py-2"},[(_vm.user)?_c('span',[_vm._v(_vm._s(_vm.user.fullName))]):_vm._e(),_c('span',{staticClass:"font-normal"},[_vm._v(" •")]),_vm._v(" "+_vm._s(_vm.createdAt)+" ")]),_c('div',{staticClass:"text-sm px-3 py-2"},[_vm._v(" "+_vm._s(_vm.comment.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }